import { render, staticRenderFns } from "./LoadingSpinnerButton.vue?vue&type=template&id=47a4e32a&scoped=true&"
import script from "./LoadingSpinnerButton.vue?vue&type=script&lang=js&"
export * from "./LoadingSpinnerButton.vue?vue&type=script&lang=js&"
import style0 from "./LoadingSpinnerButton.vue?vue&type=style&index=0&id=47a4e32a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a4e32a",
  null
  
)

export default component.exports